import React    from 'react';

import * as images  from 'images/';
import MenuItem     from 'components/MenuItem';
import JustOrders   from 'Driver/components/Orders';

export const Orders : React.FC<{}> = props => {
    return (
        <MenuItem title={["Past Orders ",<a key='download' href='/api/driver/orders?csv'><images.Download/></a>]}>
            <JustOrders/>
        </MenuItem>
    );
}

export default Orders;